import React, { useRef } from 'react';

/**
 * Calendar Date of Birth Input Component.
 * Uses a single standard calendar picker with min/max constraints, custom styling,
 * click-to-open calendar trigger, and real-time onChange/onBlur handling.
 */
export default function DobFields({
  value = '',
  onChange,
  onBlur,
  name = 'dob',
  disabled = false,
  min,
  max,
  title,
  className = '',
  inputClassName = '',
  'data-table': dataTable,
}) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    const synthetic = {
      target: {
        name,
        value: val,
        dataset: dataTable ? { table: dataTable } : {},
      },
    };
    if (typeof onChange === 'function') {
      onChange(synthetic);
    }
  };

  const handleBlur = (e) => {
    const val = e.target.value;
    const synthetic = {
      target: {
        name,
        value: val,
        dataset: dataTable ? { table: dataTable } : {},
      },
    };
    if (typeof onBlur === 'function') {
      onBlur(synthetic);
    }
  };

  const openCalendar = () => {
    if (disabled || !inputRef.current) return;
    if (typeof inputRef.current.showPicker === 'function') {
      try {
        inputRef.current.showPicker();
      } catch (err) {
        inputRef.current.focus();
      }
    } else {
      inputRef.current.focus();
    }
  };

  return (
    <div className={`dob-calendar-wrapper ${className}`.trim()} title={title}>
      <div className="dob-input-container" onClick={openCalendar}>
        <input
          ref={inputRef}
          type="date"
          name={name}
          value={value || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          min={min}
          max={max}
          className={`dob-date-input ${inputClassName}`.trim()}
          aria-label="Date of Birth"
          placeholder="YYYY-MM-DD"
        />
      </div>
      <style>{`
        .dob-calendar-wrapper {
          width: 100%;
          margin-top: 3px;
        }
        .dob-input-container {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }
        .dob-date-input {
          box-sizing: border-box !important;
          width: 100% !important;
          min-height: 42px !important;
          height: 42px !important;
          padding: 8px 14px !important;
          border: 1px solid #ccc !important;
          border-radius: 15px !important;
          background: #fff !important;
          font-size: 15px !important;
          color: #333 !important;
          outline: none;
          cursor: pointer;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .dob-date-input:focus {
          border-color: #e53d5c !important;
          box-shadow: 0 0 0 2px rgba(229, 61, 92, 0.12) !important;
        }
        .dob-date-input:disabled {
          background: #f3f4f6 !important;
          cursor: not-allowed;
          opacity: 0.75;
        }
        .dob-date-input::-webkit-calendar-picker-indicator {
          cursor: pointer;
          opacity: 0.7;
          padding: 4px;
          margin-right: 2px;
          transition: opacity 0.2s;
        }
        .dob-date-input::-webkit-calendar-picker-indicator:hover {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}
